export abstract class ObjectBaseService {
  abstract update(object: any)
  abstract appUsers()
  abstract accountUsers()
  abstract appSuites();
}